import en from './en';
import he from './he';

const terms = { en, he };

export default terms;
